import React, { Component, Fragment } from 'react';

import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';

import { Redirect, withRouter } from 'react-router-dom';
import { Query } from 'react-apollo';
import Header from './Header';
import gql from 'graphql-tag';
import Loading from '../shared/Loading';
import PayBalance from '../NewPayments/PayBalance';
import { StripeProvider } from 'react-stripe-elements';

class UpdateMobile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      payBalance: false,
      payingBalance: false
    };
  }

  connectFunc = () => this.props.history.push('/connect');

  bankingFunc = () => this.props.history.push('/banking-info');

  paymentFunc = () => this.setState({ payBalance: true });

  hstFunc = () => this.props.history.push('/hst');

  passwordFunc = () => this.props.history.push('/update-password');

  deactivateFunc = () => {
    this.props.toggleDeactivateModal();
  };
  togglePayingBalance = () => {
    this.setState({ payingBalance: !this.state.payingBalance });
  };

  render() {
    const {
      uberURL,
      connectedUberEmail,
      status,
      viaStatus,
      operatingCity,
      history
    } = this.props;
    const { payBalance, pingBalance } = this.state;
    const api_key = operatingCity === "toronto" ? process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY : process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY_US
    let content = [
      {
        title:
          operatingCity === 'toronto'
            ? 'Connected Account'
            : `Via Account Status: ${viaStatus || 'unknown'}`,
        onClick: operatingCity === 'toronto' ? this.connectFunc : () => {},
        active: true,
        hideIcon: operatingCity !== 'toronto'
      },
      {
        title: 'Payment Methods',
        onClick: this.paymentFunc,
        active: true
      },
      {
        title: 'Banking Information',
        onClick: this.bankingFunc,
        active: true
      },
      { title: 'Add HST Number', onClick: this.hstFunc, active: true },
      {
        title: 'Change Password',
        onClick: this.passwordFunc,
        active: true
      },
      {
        title: `${
          status === 'closed'
            ? 'Reactivate Account'
            : status === 'pending_reactivation'
            ? 'Cancel Reactivation Request'
            : 'Deactivate Account'
        }`,
        onClick: this.deactivateFunc,
        active: !(
          status === 'blacklisted' || status === 'negative_balance'
        )
      }
    ];
    if (operatingCity === 'new_york') {
      content = [
        {
          title:
            operatingCity === 'toronto'
              ? 'Connected Account'
              : `Via Account Status: ${viaStatus || 'unknown'}`,
          onClick:
            operatingCity === 'toronto' ? this.connectFunc : () => {},
          active: true,
          hideIcon: operatingCity !== 'toronto'
        },
        {
          title: 'Banking Information',
          onClick: this.bankingFunc,
          active: true
        },
        {
          title: 'Change Password',
          onClick: this.passwordFunc,
          active: true
        },
        {
          title: `${
            status === 'closed'
              ? 'Reactivate Account'
              : status === 'pending_reactivation'
              ? 'Cancel Reactivation Request'
              : 'Deactivate Account'
          }`,
          onClick: this.deactivateFunc,
          active: !(
            status === 'blacklisted' || status === 'negative_balance'
          )
        }
      ];
    }
    return (
      <Query
        query={gql`
          query PaymentIndex {
            currentUser {
              id
              email
              firstName
              lastName
              fullName
              operatingCity
              stripeCustomerId
              financingRequested
            }
          }
        `}
        fetch-policy="network-only">
        {({ loading, error, data, refetch }) => {
          if (error) {
            console.log(error);
            return <Redirect to="/404" />;
          }
          if (loading) return <Loading size="3x" />;
          const isTablet = window.innerWidth >= 768;
          return (
            <Fragment>
              <div className="profile__account-options--container">
                {payBalance ? (
                <StripeProvider apiKey={api_key}>
                  <PayBalance
                    history={history}
                    latestStatement={data.latestStatement}
                    currentUser={data.currentUser}
                    amount={Math.abs(
                      data.latestStatement
                        ? data.latestStatement.realTimeBalance
                        : null
                    )}
                    togglePayingBalance={this.togglePayingBalance}
                  />
                </StripeProvider>
                ) : (
                  content.map(element =>
                    element.active ? (
                      <div
                        className="profile__account-options--element"
                        onClick={element.onClick}>
                        <div className="profile__account-options--title">
                          {element.title}
                        </div>
                        {element.hideIcon ? null : (
                          <FontAwesomeIcon
                            className="profile__account-options--icon"
                            icon={faChevronRight}
                          />
                        )}
                      </div>
                    ) : null
                  )
                )}
              </div>
            </Fragment>
          );
        }}
      </Query>
    );
  }
}

export default withRouter(UpdateMobile);



// WEBPACK FOOTER //
// ./src/components/NewProfile/AccountOptions.js